<template>
    <div class="template" id="img-creative">
        <div class="template-body">
            <div class="template-group">
                <!-- 图片上传 -->
                <div class="panel-row">
                    <p class="panel-row-label">
                        <span>图片上传</span>
                        <span v-if="!imgList.length && blur.imgUrl" class="panel-row-error">
                            <Icon class="panel-row-error-icon" type="close-circled"></Icon>请上传至少一张图片
                        </span>
                    </p>
                    <div class="banner-img-list">
                        <!-- 上传框 -->
                        <div class="banner-img-item">
                            <!-- 影子元素 -->
                            <input
                                ref="imgUrl"
                                type="file"
                                hidden
                                :multiple="status.action != 'edit' || status.type != 'creative'"
                                accept="image/jpeg,image/jpg,image/png"
                                @change="onFileChange($event)"
                            />
                            <!-- 上传中动画 -->
                            <cSpin v-if="loading" :size="0.1" :radius="0.05" color="#23c52f" background="#fafafa" />
                            <div @click="$refs.imgUrl.click()" class="item-upload">
                                <Icon class="item-upload-icon" type="plus-round"></Icon>
                                <span class="item-upload-text">上传</span>
                            </div>
                        </div>

                        <!-- 缩略图框 -->
                        <div v-for="(item, index) in imgList" :key="index" class="banner-img-item">
                            <div
                                @mouseover="item.showFunction = true"
                                @mouseout="item.showFunction = false"
                                class="item-img-box"
                            >
                                <img class="item-img" :src="item.imgUrl" />
                                <transition name="fade">
                                    <div v-show="item.showFunction" class="img-function">
                                        <span
                                            @click="previewImg(item.imgUrl, imgSizeList[item.sizeType])"
                                            class="function-icon"
                                            ><Icon type="eye"></Icon
                                        ></span>
                                        <span @click="remove(index)" class="function-icon"
                                            ><Icon type="android-delete"></Icon
                                        ></span>
                                    </div>
                                </transition>
                            </div>
                        </div>
                    </div>
                    <p class="panel-row-label no-margin">尺寸：320x480，320x50，300x250;格式：jpg，png；大小：500KB</p>
                </div>
            </div>
        </div>
        <div class="template-footer">
            <Button @click="show.library = true" type="info" size="large">创意库选择</Button>
        </div>

        <library v-model="show.library" :creativeType="1" @submit="onLibrarySubmit" />
    </div>
</template>
<script>
import library from '@/components/NewPromotion/library.vue';
import cSpin from '@/components/commons/cSpin.vue';
import mixins from '@/mixins/index';
export default {
    mixins: [mixins],
    components: { cSpin, library },
    props: {
        blur: {
            type: Object,
        },
    },
    data() {
        return {
            show: {
                library: false,
            },
            loading: false,
        };
    },
    computed: {
        status() {
            return this.$store.state.newPromotion.status;
        },
        imgList() {
            return this.$store.state.newPromotion.imgList;
        },
        imgSizeList() {
            return this.$store.state.newPromotion.imgSizeList;
        },
    },
    methods: {
        /**
         * @desc 从创意库选择创意
         * @param {Array} arr 创意对象
         */
        onLibrarySubmit(arr) {
            console.log(arr);
            this.$store.commit('imgList', [...this.imgList, ...arr]);
        },
        /**
         * @desc 移除图片
         */
        remove(index) {
            const arr = [...this.imgList];
            arr.splice(index, 1);
            this.$store.commit('imgList', arr);
        },
        /**
         * @desc 上传图片
         * @param {Event} e: 原生input事件
         */
        onFileChange(e) {
            const files = Array.from(e.target.files);
            //没有选择图片则返回
            if (!files.length) return;

            // 尺寸限制200k
            if (files.some((file) => file.size > 1024 * 500)) {
                this.$Message.error({ content: '请上传正确大小的图片', duration: 2 });
                return;
            }
            // 尺寸限制

            this.verifyImgSize(files, this.imgSizeList, async (sizeList) => {
                this.loading = true;

                const formData = new FormData();
                files.forEach((file) => formData.append('img', file));
                const res = await this.$axios.post(this.$port.manager.uploadImg, formData, { cancelLoading: true });

                //数据处理
                this.loading = false;
                const arr = [];
                res.data.urls.forEach((url, index) => {
                    arr.push({
                        imgUrl: url,
                        name: files[index].name.split('.')[0],
                        sizeType: sizeList[index],
                        showFunction: false,
                        status: 1,
                        creativeType: 1,
                    });
                });
                const result =
                    this.status.action != 'edit' || this.status.type != 'creative' ? [...this.imgList, ...arr] : arr;
                this.$store.commit('imgList', result);
                //清空input
                e.target.value = '';
                this.blur.imgUrl = true;
            });
        },
    },
};
</script>
<style lang="scss">
#img-creative {
    .template-body {
        width: 70%;
    }
}
</style>



// WEBPACK FOOTER //
// src/view/NewPromotion/Creative/ImgCreative.vue